import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Edit2 } from "lucide-react";
import { DeleteMFOButton } from "./DeleteMFOButton";

interface MFOTableActionsProps {
  mfoId: string;
  mfoCode: string;
  mfoTitle: string;
  onDelete: (id: string) => Promise<boolean>;
  onEdit?: () => void;
  type?: 'mfo' | 'code';
}

const MFOTableActions: React.FC<MFOTableActionsProps> = ({ 
  mfoId, 
  mfoCode, 
  mfoTitle, 
  onDelete,
  onEdit,
  type = 'mfo'
}) => {
  const viewRoute = type === 'mfo' ? `/dashboard/mfo/${mfoId}` : `/dashboard/mfo-codes/${mfoId}`;

  return (
    <div className="flex space-x-2">      
      {onEdit && (
        <Button 
          variant="ghost" 
          size="icon" 
          className="w-8 h-8" 
          onClick={onEdit}
        >
          <Edit2 className="h-4 w-4" />
        </Button>
      )}
      
      <DeleteMFOButton 
        mfoId={mfoId} 
        mfoCode={mfoCode} 
        mfoTitle={mfoTitle} 
        onDelete={onDelete} 
      />
    </div>
  );
};

export default MFOTableActions;
